import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  connect() {
    const mask = new Inputmask("99 99 99 99 99", {
      placeholder: " ",
      showMaskOnHover: false
    })
    mask.mask(this.element)
  }
}